import React, {Component} from 'react';
import Thumbnail from './Thumbnail';
import Slider from "react-slick";
//============================================================================
// expected props : 
//   elements : element to display
//   onElementClick(element) : called when user selects element

export default class MediaSlider extends Component {

	state = {
		slideIndex: 0,
		updateCount: 0,
		shouldSwiperResetState: false
		};
	// Check if this is the place where the movie are selected or removed
	selection() {return this.props.selection}
	/* so if this is "false" then we know that this is the popular resultset. 
		if an element has a selected = true prop then it shouldn't be display here
		in next loop if i.selected && selection === i.selected
	*/

	medias() { 
		return this.props.elements.map(i => { 
		if((this.selection() === "popular" || this.selection() === "recommend") && !i.selected){
			return (
					<Thumbnail
						key={i.id}
						score={i.vote_average}
						rec_score={(this.selection() === "popular" && this.props.query !== '') ? null : i.rec_score}
						src={i.poster_path }
						title={i.title}
						rec_title={(i.rec && i.rec.title)? i.rec.title : null}
						rec_poster_path={(i.rec && i.rec.poster_path)? i.rec.poster_path : null}
						selected={i.selected}
						category={i.genres}
						onSelect={()=>{
								this.props.onElementClick(i);
							}}
						publication_timestamp={i.release_date}
					/>
			);
		} else if(this.selection() === "history" && i.selected) {
			return (
					<Thumbnail
						key={i.id}
						score={i.vote_average}
						src={i.poster_path }
						title={i.title}
						rec_title={(i.rec && i.rec.title)? i.rec.title : null}
						rec_poster_path={(i.rec && i.rec.poster_path)? i.rec.poster_path : null}
						selected={i.selected}
						category={i.genres}
						onSelect={()=>{
								this.props.onElementClick(i);
							}}
						publication_timestamp={i.release_date}
					/>);
		} else return null;
	});
}
componentDidUpdate() {
	if(this.selection() === "recommend" && this.slider){
			this.slider.slickGoTo(0);
	}
	// Should go to start after a search
	if(this.selection() === "popular" && this.slider && this.state.shouldSwiperResetState !== this.props.shouldSwiperResetState){
		this.slider.slickGoTo(0);
		this.setState({shouldSwiperResetState:this.props.shouldSwiperResetState})
	}
}

render(){
	if(this.medias().length > 0){			
			let settings = {
				dots: false,
				infinite: false,
				className: "center",
				centerPadding: "0px",
				speed: 500,
				slidesToShow: 4,
				slideIndex: this.state.slideIndex,
				slidesToScroll: 4,
				focusOnSelect: false,
				initialSlide: 0,
				// lazyLoad: "ondemand",
				responsive: [
					{
						breakpoint: 700,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 3,
							arrows: true
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 2.25,
							slidesToScroll: 2,
							arrows: true
						}
					}
				],
				// swipeToSlide: true,
				afterChange: () => {
					if(this.selection() !== "recommend")
						this.setState(state => ({ updateCount: state.updateCount + 1 }))
				}
			};
			let searchRes = () => {
				if(this.selection() === "popular" && this.props.query && this.props.query !== '')
					return (<small className="search-result">Search for &quot;{this.props.query}&quot; took {this.props.queryTime} ms.</small>);
				return '';
					
			} 
			return (
					<div className="Slider-holder">
						
					<div style={{
							"width":"100%",
							"align":"center",
							"padding": "25px 20px 20px 0",
							}}>
						{searchRes()}
						<Slider ref={slider => this.slider = slider} {...settings}>{this.medias()}</Slider>
					</div>
					<div className="sliderBreak"></div>
				</div>
			);			
	} else {
		if(this.selection() === "recommend")
			return (<div><h4 style={{color:'#aaa', marginTop: '50px'}}>You have to add a movie to the user history to receive a recommendation.</h4></div>);
			return (<div></div>);
	}
 }	
}
